import React from "react";
import { empiTheme } from "./styles/empiTheme";

export default function DayWithEmPi() {
  return (
    <section style={section} className="empi-section-tight">
      <div style={wrap}>
        <div style={eyebrow}>A day with EmPi</div>
        <h2 style={h2}>From confusion → cooperation.</h2>

        <div style={twoCol} className="empi-two-col">
          <div style={boxMuted}>
            <div style={label}>Instead of</div>
            <div style={quote}>“Why am I so tired today?”</div>
            <div style={text}>
              You push harder, blame yourself, and try to override your body.
            </div>
          </div>

          <div style={box}>
            <div style={label}>With EmPi</div>
            <div style={quote}>
              “Today my body is in a slower rhythm — I’ll eat warmly, move
              gently, and plan instead of forcing.”
            </div>
            <div style={text}>
              You make choices that fit today — and tomorrow feels easier.
            </div>
          </div>
        </div>

        <div style={cta}>
          <div>
            <div style={ctaTitle}>The first EmPi pilot is complete.</div>
            <div style={ctaText}>
              Thank you to everyone who helped test the first experience. EmPi
              is now preparing its next phase.
            </div>
          </div>

          <a href="#waitlist" style={btnPrimary}>
            Pilot status
          </a>
        </div>
      </div>
    </section>
  );
}

const section = {
  padding: empiTheme.layout.sectionPadding,
  background: empiTheme.colors.background,
};

const wrap = {
  maxWidth: empiTheme.layout.maxWidth,
  margin: "0 auto",
};

const eyebrow = {
  ...empiTheme.typography.eyebrow,
  color: empiTheme.colors.textSecondary,
  marginBottom: 12,
};

const h2 = {
  fontSize: empiTheme.typography.h2.fontSize,
  lineHeight: empiTheme.typography.h2.lineHeight,
  color: empiTheme.colors.text,
  margin: "0 0 18px",
  maxWidth: 760,
};

const twoCol = {
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  gap: 16,
};

const boxBase = {
  border: `1px solid ${empiTheme.colors.border}`,
  borderRadius: empiTheme.radius.card,
  padding: 18,
  boxShadow: empiTheme.shadow.card,
};

const boxMuted = {
  ...boxBase,
  background: "#FAFAFA",
};

const box = {
  ...boxBase,
  background: empiTheme.colors.surface,
};

const label = {
  fontSize: 12,
  textTransform: "uppercase",
  letterSpacing: 1.2,
  color: empiTheme.colors.textSecondary,
  marginBottom: 10,
};

const quote = {
  fontSize: 18,
  fontWeight: 700,
  lineHeight: 1.45,
  marginBottom: 10,
  color: empiTheme.colors.text,
};

const text = {
  fontSize: 15,
  lineHeight: 1.65,
  color: empiTheme.colors.textSecondary,
};

const cta = {
  marginTop: 20,
  border: `1px solid ${empiTheme.colors.border}`,
  borderRadius: empiTheme.radius.card,
  padding: 20,
  background: empiTheme.colors.surface,
  display: "flex",
  gap: 14,
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  boxShadow: empiTheme.shadow.card,
};

const ctaTitle = {
  fontSize: 16,
  fontWeight: 700,
  marginBottom: 4,
  color: empiTheme.colors.text,
};

const ctaText = {
  fontSize: 14,
  lineHeight: 1.6,
  color: empiTheme.colors.textSecondary,
  maxWidth: 560,
};

const btnPrimary = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "12px 16px",
  borderRadius: empiTheme.radius.button,
  background: "linear-gradient(180deg, #F8C9B6 0%, #F4A98A 100%)",
  color: "#3A2A24",
  textDecoration: "none",
  fontWeight: 700,
  border: "1px solid #F2B79D",
  boxShadow: "0 5px 12px rgba(244, 169, 138, 0.24)",
};
